(ns arthur.domain.keyframes
  (:require [arthur.domain.channel :as ch]))

(defn identity-of [k] (select-keys k [:sid :id :channel :frame]))

(defn shifted [items delta]
  (let [delta (max delta (reduce max js/Number.NEGATIVE_INFINITY (map #(max (- (:at %)) (- (* (:frame %) (:scale %)))) items)))]
    (mapv (fn [k]
            (let [f (max 0 (js/Math.round (+ (:frame k) (/ delta (:scale k)))))]
              (assoc k :frame f :at (+ (:at k) (* (:scale k) (- f (:frame k))))))) items)))

(defn edit-keys [document items delta]
  (let [targets-by-id (when (some? delta)
                        (into {} (map vector (map identity-of items) (shifted items delta))))]
   (reduce
   (fn [doc [[sid id channel] selected]]
     (let [path [:symbols sid :nodes id :channels channel]
           c (get-in doc path)
           selected (filter #(contains? (:keys c) (:frame %)) selected)
           targets (when (some? delta) (mapv #(get targets-by-id (identity-of %)) selected))
           remaining (apply dissoc (:keys c) (map :frame selected))
           ks (if targets
                (reduce (fn [ks [old new]] (assoc ks (:frame new) (get (:keys c) (:frame old))))
                        remaining (map vector selected targets))
                remaining)
           segments (apply dissoc (:segments c) (concat (map :frame selected) (map :frame targets)))
           segments (if targets
                      (reduce (fn [s [old new]]
                                (if (contains? (:segments c) (:frame old))
                                  (assoc s (:frame new) (get (:segments c) (:frame old))) s))
                              segments (map vector selected targets)) segments)]
       (if (empty? selected) doc
           (assoc-in doc path
                     (if (seq ks)
                       (cond-> (assoc c :keys ks) (:segments c) (assoc :segments segments))
                       (ch/framed (get (:keys c) (:frame (last selected)))))))))
   document (group-by (juxt :sid :id :channel) (vals (into {} (map (juxt identity-of identity) items)))))))
